export default {
  colors: {
    black: '#000e1a',
    white: '#fff',
    green: '#01bf71',
    lila: '#9f2fff'
  }
};
